import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AgVirtualSrollComponent } from 'ag-virtual-scroll';
import { environment } from 'projects/environments/environment';
import { generateModuleMenuURL, getAccessTokenPayloadInfo } from 'projects/lib-shared-common/src/public-api';
import { UserAvatarSize } from '@solvace/component/svc-user-avatar';
import { SvcToastService } from '@solvace/component/svc-toast';
import { TasksModule } from '../models/tasks-module';
import { CommomAnalyticsIndicator } from '../models/commom-analytics-indicator';

@Component({
  selector: 'main-task',
  templateUrl: './main-task.component.html',
  styleUrls: ['./main-task.component.scss'],
})
export class MainTaskComponent implements AfterViewInit {
  private readonly _toastService = inject(SvcToastService);
  private readonly _translocoService = inject(TranslocoService);
  private readonly _cdr = inject(ChangeDetectorRef);

  @Input() tasks: any[];
  @Input() isTotalTasksLoading: boolean;
  @Output() onActionPlanClick = new EventEmitter<CommomAnalyticsIndicator>();
  @Output() onDefectTagClick = new EventEmitter<CommomAnalyticsIndicator>();
  @Output() onCilClick = new EventEmitter<CommomAnalyticsIndicator>();

  @ViewChild(AgVirtualSrollComponent) agVirtualSroll: AgVirtualSrollComponent;

  protected taskModules = TasksModule;
  protected avatarSize: UserAvatarSize = UserAvatarSize.Tasks;

  public env = environment;

  ngAfterViewInit(): void {
    this.agVirtualSroll?.refreshData();
    this._cdr.detectChanges();
  }

  openModuleItem(item: any) {
    if (item.moduleName === TasksModule.ACTIONPLAN) {
      this.onActionPlanClick.emit(item);
      return;
    }

    if (item.moduleName === TasksModule.DEFECTTAG) {
      this.onDefectTagClick.emit(item);
      return;
    }

    if (item.moduleName === TasksModule.CIL) {
      this.onCilClick.emit(item);
      return;
    }

    //use this code below to change to legacy modal instead of opening at different tab
    const issuer = getAccessTokenPayloadInfo('iss');
    let fnc = null;
    let urlToOpen: string | undefined;

    switch (item.moduleName) {
      case TasksModule.CHECKLIST:
        urlToOpen = '/checklist/Inspection/View';
        fnc = generateModuleMenuURL(
          'MESSAGE',
          issuer,
          'openModal',
          `{"functionName": "OpenDynamicModal", "urlToOpen": "${urlToOpen}", "modalData": { "inspectionId": ${item.inspectionId}, "flEdit":false}, "modalId": "#registry-inspection-modal", "modalTimeout": 0}`
        );
        break;
    }
    // Initialize legacy callbacks for the specific module URL if available.
    // The legacy `_overrideCallbacks` lives inside the legacy iframe (`#legacy-modal-support`).
    try {
      let overrideFn: any = undefined;
      const iframe = document.querySelector('#legacy-modal-support') as HTMLIFrameElement | null;
      const iframeWin = iframe?.contentWindow as any | undefined;
      if (iframeWin && typeof iframeWin._overrideCallbacks === 'function') {
        overrideFn = iframeWin._overrideCallbacks.bind(iframeWin);
      } else if (typeof (window as any)._overrideCallbacks === 'function') {
        // fallback to top-level if, for some reason, it's exposed there
        overrideFn = (window as any)._overrideCallbacks;
      }

      if (urlToOpen && typeof overrideFn === 'function') {
        overrideFn(urlToOpen);
      }
    } catch (e) {
      // ignore errors from legacy function
    }

    if (typeof fnc === 'function') fnc();
  }

  openInpectionNok(item: any, event: any) {
    if (event.label !== 'NOK') return;
    const module = item.moduleName === TasksModule.CHECKLIST ? 'checklist' : 'lil';
    const issuer = getAccessTokenPayloadInfo('iss');
    const fnc = generateModuleMenuURL(
      'MESSAGE',
      issuer,
      'openModal',
      `{"functionName": "OpenDynamicModal", "urlToOpen": "/${module}/Inspection/ListDetailNoOk", "modalData": { "inspectionId": ${item.inspectionId}, "flEdit":false}, "modalId": "#registry-inspection-modal", "modalTimeout": 0}`
    );
    if (typeof fnc === 'function') fnc();
  }

  handleBookmarkChange(task: any, newValue: boolean, fromObtained: boolean = false): void {
    task.isBookmark = newValue;
    if (!fromObtained) {
      const messageKey = newValue ? 'adicionado aos' : 'removido dos';
      this._toastService.success(this._translocoService.translate(`Registro ${messageKey} favoritos com sucesso`));
    }
  }
}
